<script setup lang="ts">
import { useTemplateRef } from 'vue'

import { Button } from '@collector/shared-ui'
import { useElementBounding, useWindowSize } from '@vueuse/core'

type Props = {
  dirty?: boolean
  isStatsVerified?: boolean
  isVerifyStatsButtonDisabled?: boolean
}
defineProps<Props>()

type Emits = {
  submit: [void]
  verify: [void]
}
const emit = defineEmits<Emits>()

// composables
const stickyFooter = useTemplateRef('stickyFooter')
const { bottom } = useElementBounding(stickyFooter)
const { height } = useWindowSize()
</script>

<template>
  <div
    ref="stickyFooter"
    class="bg-neutral-light-10/70 sticky bottom-0 -mx-2 mt-3 flex justify-center gap-x-5 p-3 backdrop-blur-md transition-shadow"
    :class="{
      'shadow-[0px_-4px_6px_0px_rgba(0,_0,_0,_0.1)]':
        Math.floor(height) === Math.floor(bottom),
    }"
  >
    <Button
      class="bg-neutral-light-10 px-8 font-bold"
      :class="{
        'text-neutral-light-10 bg-success-2 hover:bg-success-4 active:bg-success-5 active:transition-none':
          dirty,
      }"
      size="md"
      color="blue-light"
      :disabled="!dirty"
      @click="emit('submit')"
    >
      Save
    </Button>
    <Button
      class="font-bold"
      :class="{
        'border-success-3 text-success-3 border opacity-50': isStatsVerified,
        'border-neutral-light-0 bg-neutral-light-7 hover:bg-neutral-light-2 hover:border-neutral-light-2 text-neutral-dark-0':
          !isVerifyStatsButtonDisabled,
      }"
      :disabled="isVerifyStatsButtonDisabled"
      size="md"
      color="blue-light"
      @click="emit('verify')"
    >
      Verify team & player statistics
    </Button>
  </div>
</template>
